(() => {
  'use strict';

  if (window.__vistaracerKitSyncLoaded) return;
  window.__vistaracerKitSyncLoaded = true;

  const ROOT = window.Shopify?.routes?.root || '/';

 const CAR_HANDLES = new Set([
  'mini-rc-auto',
  'mini-rc-monster'
]);

const CAR_TITLES = new Set([
  'mini rc-auto',
  'mini rc-auto mit live-kamera',
  'mini rc monster',
  'mini rc monster mit live-kamera'
]);
  const KIT_HANDLE = 'rc-kit-vistaracer';
  const KIT_TITLES = new Set(['rc-kit vistaracer']);

  const originalFetch = window.fetch.bind(window);
  let syncTimer;
  let activeSync = null;
  let repeatSync = false;
  let checkoutPending = false;

  const normalize = (value) =>
    String(value || '').trim().toLowerCase();

  const isCar = (item) =>
    CAR_HANDLES.has(normalize(item.handle)) ||
    CAR_TITLES.has(normalize(item.product_title));

  const isKit = (item) =>
    normalize(item.handle) === KIT_HANDLE ||
    KIT_TITLES.has(normalize(item.product_title));

  const fetchJSON = async (url, options = {}) => {
    const response = await originalFetch(url, options);

    if (!response.ok) {
      throw new Error(`VistaRacer: error ${response.status}`);
    }

    return response.json();
  };

  const getDrawerSections = () => {
    const drawer = document.querySelector('cart-drawer');

    if (!drawer || typeof drawer.getSectionsToRender !== 'function') {
      return [];
    }

    try {
      return [
        ...new Set(
          drawer
            .getSectionsToRender()
            .map((section) => section.section || section.id)
            .filter(Boolean)
        ),
      ].slice(0, 5);
    } catch (error) {
      return [];
    }
  };

  const getSectionData = () => {
    const sections = getDrawerSections();

    if (!sections.length) return {};

    return {
      sections,
      sections_url: window.location.pathname,
    };
  };

  const refreshCartDrawer = (cart) => {
    const drawer = document.querySelector('cart-drawer');

    if (
      drawer &&
      cart?.sections &&
      typeof drawer.renderContents === 'function'
    ) {
      try {
        drawer.renderContents(cart);
      } catch (error) {
        console.warn('VistaRacer: no se pudo refrescar el carrito.', error);
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart,
          openMiniCart: false,
        },
      })
    );
  };

  const updateCart = async (updates) => {
    const cart = await fetchJSON(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        updates,
        ...getSectionData(),
      }),
    });

    refreshCartDrawer(cart);
    return cart;
  };

  const addMissingKit = async (quantity) => {
    const product = await fetchJSON(
      ROOT + `products/${KIT_HANDLE}.js`
    );

    const variant =
      product.variants.find((item) => item.available) ||
      product.variants[0];

    if (!variant) {
      throw new Error('VistaRacer: no se encontró la variante del RC-Kit.');
    }

    await fetchJSON(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variant.id,
            quantity,
            properties: {
              _vistaracer_gratis: 'RC-Kit pro Auto',
            },
          },
        ],
      }),
    });

    const updatedCart = await fetchJSON(ROOT + 'cart.js');
    const kit = updatedCart.items.find(isKit);

    if (kit) {
      await updateCart({
        [kit.key]: quantity,
      });
    }
  };

  const performSync = async () => {
    const cart = await fetchJSON(ROOT + 'cart.js');

    const requiredKits = cart.items
      .filter(isCar)
      .reduce((total, item) => total + item.quantity, 0);

    const kitLines = cart.items.filter(isKit);

    if (requiredKits === 0) {
      if (!kitLines.length) return;

      const updates = {};

      kitLines.forEach((item) => {
        updates[item.key] = 0;
      });

      await updateCart(updates);
      return;
    }

    if (!kitLines.length) {
      await addMissingKit(requiredKits);
      return;
    }

    if (
      kitLines.length === 1 &&
      kitLines[0].quantity === requiredKits
    ) {
      return;
    }

    const updates = {
      [kitLines[0].key]: requiredKits,
    };

    kitLines.slice(1).forEach((item) => {
      updates[item.key] = 0;
    });

    await updateCart(updates);
  };

  const syncKitQuantity = async () => {
    if (activeSync) {
      repeatSync = true;
      return activeSync;
    }

    activeSync = (async () => {
      do {
        repeatSync = false;

        try {
          await performSync();
        } catch (error) {
          console.error('VistaRacer Kit Sync:', error);
        }
      } while (repeatSync);
    })();

    try {
      await activeSync;
    } finally {
      activeSync = null;
    }
  };

  const scheduleSync = (delay = 250) => {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncKitQuantity, delay);
  };

  const getRequestPath = (input) => {
    try {
      const url =
        typeof input === 'string'
          ? input
          : input instanceof Request
            ? input.url
            : '';

      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  };

  const isCartMutation = (input, options = {}) => {
    const method = String(
      options.method ||
        (input instanceof Request ? input.method : 'GET')
    ).toUpperCase();

    const path = getRequestPath(input);

    return (
      method !== 'GET' &&
      /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(path)
    );
  };

  window.fetch = async (...args) => {
    const cartMutation = isCartMutation(args[0], args[1]);
    const response = await originalFetch(...args);

    if (cartMutation) scheduleSync();

    return response;
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this.__vistaracerCartMutation =
      String(method).toUpperCase() !== 'GET' &&
      /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(
        getRequestPath(url)
      );

    return originalXHROpen.call(this, method, url, ...args);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__vistaracerCartMutation) {
      this.addEventListener(
        'loadend',
        () => {
          if (this.status >= 200 && this.status < 400) {
            scheduleSync();
          }
        },
        { once: true }
      );
    }

    return originalXHRSend.apply(this, args);
  };

  document.addEventListener(
    'click',
    (event) => {
      const checkoutButton = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
      );

      if (!checkoutButton || checkoutPending) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      checkoutPending = true;

      syncKitQuantity().finally(() => {
        const destination =
          checkoutButton.tagName === 'A' && checkoutButton.href
            ? checkoutButton.href
            : ROOT + 'checkout';

        window.location.assign(destination);
      });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => scheduleSync(400),
      { once: true }
    );
  } else {
    scheduleSync(400);
  }

  window.addEventListener('pageshow', () => scheduleSync(300));
})();